"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_PROFILE_TABS = exports.MAINTENANCE_TABS = void 0;
const react_1 = __importDefault(require("react"));
const RightsholderMaintenanceBankingTabHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/RightsholderMaintenanceBankingTabHeader"));
const RightsholderMaintenanceContactTabHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactTabHeader"));
exports.MAINTENANCE_TABS = {
    mailingAndContact: {
        name: 'Mailing and Contact',
        description: react_1.default.createElement(RightsholderMaintenanceContactTabHeader_1.default, null),
    },
    bankingAndTax: {
        name: 'Banking and Tax',
        description: react_1.default.createElement(RightsholderMaintenanceBankingTabHeader_1.default, null),
    },
};
exports.USER_PROFILE_TABS = {
    user: 'User',
    rightsholders: 'Members',
    songwriters: 'Songwriters',
};
